<template>
  <div style="padding-top: 100px; margin-bottom: 100px">
    <!-- STEPPER -->
    <v-stepper
      tile
      v-model="current"
      alt-labels
      style="position: fixed; top: 47px; left: 0; z-index: 4; width: 100%; border-radius: 0"
    >
      <v-stepper-header class="white">
        <template v-for="(step, index) in steps">
          <v-stepper-step
            :key="`step-${step.id}`"
            :complete="current > index"
            :step="step.id"
            :color="current > step.id ? 'success' : 'primary'"
          >
            {{ step.title }}
          </v-stepper-step>
          <v-divider v-if="index < steps.length - 1" :key="`step-${step.id}-divider`"></v-divider>
        </template>
      </v-stepper-header>
    </v-stepper>

    <!-- CONTENT -->
    <v-tabs-items v-model="current" background-color="transparent" style="background-color: transparent !important">
      <v-tab-item :value="0">
        <user-frontpage-form v-model="survey" ref="frontpageForm" />
      </v-tab-item>
      <v-tab-item v-for="(step, index) in daySteps" :key="step.id">
        <!-- <journey-list :journeys="getJourneysByDay(index)" @edit="onEdit" @delete="onDelete" /> -->
        <base-journey-card
          v-for="journey in getJourneysByDay(index)"
          :journey="journey"
          @click:edit="onEdit(journey)"
          @click:delete="onDelete(journey)"
          :key="journey.id"
          :disable-delete="journey.id !== lastJourney.id"
        />
      </v-tab-item>
      <v-tab-item :value="8">
        <h4 class="text-h4 mt-5">Compilazione completata</h4>
        <div class="text-body-1 mt-5">
          Hai compilato correttamente il questionario, clicca sul pulsante "Invia questionario" per terminare.
        </div>
      </v-tab-item>
    </v-tabs-items>

    <template v-if="isInDayStep">
      <div v-if="!canAddJourney" my-0 mb-n3 pt-3 icon="mdi-map-marker-off" large color="info">
        <v-alert type="info" text rounded="lg" class="my-3">
          Non puoi più aggiungere altri viaggi per questa data poichè ci sono già dei viaggi nelle date successive.
        </v-alert>
      </div>
      <div v-else>
        <div class="text-body-1 py-2 px-1">Aggiungi un viaggio per questo giorno della rilevazione</div>
        <v-card rounded="lg">
          <!-- <v-divider /> -->
          <v-card-text class="">
            <v-row class="">
              <template v-if="!nextJourneyStartsFrom">
                <!-- <v-col cols="12" class="pt-0 mb-0 pb-0">
                  <v-alert dense text type="info" tile class="mx-n3 mb-0">
                    Inserisci qui la località di <strong>partenza</strong> del viaggio.
                  </v-alert></v-col
                > -->
                <v-col sm="8">
                  <search-place-field
                    v-model="newJourneyForm.from"
                    label="Località di partenza"
                    hide-details
                    placeholder="Digita la località, comune o provincia di partenza"
                    persistent-placeholder
                    prepend-icon="mdi-map-marker"
                    ref="placeInput"
                    id="placeInput"
                    outlined
                    dense
                    class="rounded-lg"
                    flat
                    :menu-props="{ top: true, offsetY: true, rounded: 'rounded' }"
                  />
                </v-col>
                <v-col sm="4">
                  <v-select
                    v-model="newJourneyForm.from_type"
                    :items="placeTypeItems"
                    item-value="id"
                    item-text="desc"
                    label="Tipologia"
                    :disabled="!newJourneyForm.from"
                    hide-details
                    background-color="white"
                    class="rounded-lg"
                    flat
                    placeholder="Seleziona la tipologia"
                    outlined
                    dense
                  >
                    <template #item="{ item }">
                      <v-icon left>{{ item.icon }}</v-icon>
                      {{ item.desc }}
                    </template>
                    <template #selection="{ item }">
                      <v-icon left>{{ item.icon }}</v-icon>
                      {{ item.desc }}
                    </template>
                  </v-select>
                </v-col>
              </template>
              <template v-else>
                <v-col sm="8">
                  <v-text-field
                    :value="nextJourneyStartsFrom.place.full_name"
                    label="Località di partenza"
                    hide-details
                    placeholder="Digita la località, comune o provincia di partenza"
                    persistent-placeholder
                    prepend-icon="mdi-map-marker"
                    ref="placeInput"
                    id="placeInput"
                    dense
                    class="rounded-lg"
                    flat
                    outlined
                    readonly
                    disabled
                  />
                </v-col>
                <v-col sm="4">
                  <v-select
                    :value="nextJourneyStartsFrom.type"
                    :items="placeTypeItems"
                    item-value="id"
                    item-text="desc"
                    label="Tipologia"
                    hide-details
                    background-color="white"
                    class="rounded-lg"
                    flat
                    placeholder="Seleziona la tipologia"
                    :append-icon="null"
                    readonly
                    outlined
                    disabled
                    dense
                  >
                    <template #item="{ item }">
                      <v-icon left>{{ item.icon }}</v-icon>
                      {{ item.desc }}
                    </template>
                    <template #selection="{ item }">
                      <v-icon left>{{ item.icon }}</v-icon>
                      {{ item.desc }}
                    </template>
                  </v-select>
                </v-col>
              </template>
            </v-row>
            <v-row>
              <!-- <v-col cols="12" class="pt-0 mb-0 pb-0" v-if="getJourneys.length === 0">
                <v-alert dense text type="info" tile class="mx-n3 mb-0">
                  Inserisci qui la località di <strong>arrivo</strong> del viaggio.
                </v-alert>
              </v-col> -->
              <v-col sm="8">
                <search-place-field
                  v-model="newJourneyForm.to"
                  label="Località di arrivo"
                  hide-details
                  placeholder="Digita la località, comune o provincia di arrivo"
                  persistent-placeholder
                  prepend-icon="mdi-map-marker-outline"
                  ref="placeInput"
                  id="placeInput"
                  class="rounded-lg"
                  outlined
                  flat
                  dense
                />
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="newJourneyForm.to_type"
                  :items="placeTypeItems"
                  item-value="id"
                  item-text="desc"
                  label="Tipologia"
                  placeholder="Seleziona la tipologia"
                  :disabled="!newJourneyForm.to"
                  outlined
                  hide-details
                  background-color="white"
                  class="rounded-lg"
                  flat
                  dense
                >
                  <template #item="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.desc }}
                  </template>
                  <template #selection="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.desc }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- <v-divider></v-divider> -->
          <v-card-actions class="pt-0">
            <v-spacer />
            <v-btn
              class="rounded-lg px-3"
              color="primary"
              :disabled="!(newJourneyForm.to && newJourneyForm.to_type)"
              depressed
              @click="openNewJourneyDialog"
              >Nuovo viaggio</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </template>

    <v-dialog v-model="dialog" width="98%" persistent>
      <v-card rounded="xl" tile>
        <journey-form
          v-if="dialog"
          dense
          v-bind="formProps"
          @submit="onJourneyFormSubmit"
          ref="form"
          @close="dialog = false"
        />
      </v-card>
    </v-dialog>

    <!-- TOOLBAR -->
    <v-toolbar elevation="4" width="100%" style="position: fixed; left: 0; bottom: 0">
      <v-btn class="rounded-lg" depressed @click="onClickBack" :disabled="!canGoBack"> Indietro </v-btn>

      <v-spacer></v-spacer>

      <v-btn color="primary" class="rounded-lg" depressed @click="onClickContinue"> {{ continueBtnLabel }} </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
// Components
import EditSurveyForm from '@/components/forms/EditSurveyForm.vue'
import UserFrontpageForm from '@/components/forms/UserFrontpageForm.vue'
import JourneyForm from '@/components/forms/JourneyForm.vue'
// import JourneyList from '@/components/JourneyList.vue'
import BaseJourneyCard from '@/components/BaseJourneyCard.vue'
import SearchPlaceField from '@/components/forms/SearchPlaceField.vue'

// Third-party libs
import { format } from 'date-fns'
import { it } from 'date-fns/locale'

// Store
import { mapState, mapGetters, mapActions } from 'vuex'

// Types
import { placeTypes } from '@/types'
import { JourneyType } from '@/types/enum'
import firebase from 'firebase/app'

// Component
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EditSurveyForm,
    UserFrontpageForm,
    // JourneyList,
    JourneyForm,
    BaseJourneyCard,
    SearchPlaceField,
  },
  data() {
    return {
      current: null,
      dialog: false,
      steps: [
        { id: 0, title: 'Dati impresa' },
        { id: 1, title: 'Lunedì' },
        { id: 2, title: 'Martedì' },
        { id: 3, title: 'Mercoledì' },
        { id: 4, title: 'Giovedì' },
        { id: 5, title: 'Venerdì' },
        { id: 6, title: 'Sabato' },
        { id: 7, title: 'Domenica' },
        { id: 8, title: 'Fine' },
      ],
      formProps: {},
      newJourneyForm: {
        from: null,
        from_type: null,
        to: null,
        to_type: null,
      },
      placeTypeItems: [
        { id: 'D', desc: 'Deposito', icon: 'mdi-home' },
        { id: 'I', desc: 'Interporto', icon: 'mdi-home-city' },
        { id: 'P', desc: 'Porto', icon: 'mdi-ferry' },
        { id: 'A', desc: 'Aeroporto', icon: 'mdi-airport' },
        { id: 'S', desc: 'Stazione ferroviaria', icon: 'mdi-train' },
        { id: 'X', desc: 'Altro', icon: 'mdi-map-marker-outline' },
      ],
    }
  },
  computed: {
    ...mapState('survey', ['survey', 'loading']),
    ...mapGetters('survey', {
      getJourneys: 'getJourneys',
      lastJourney: 'getLastJourney',
      hasJourneys: 'hasJourneys',
      firstJourneyId: 'getFirstJourneyId',
      lastJourneyId: 'getLastJourneyId',
      isFirstDay: 'isFirstDay',
      isLastDay: 'isLastDay',
      getWeekDates: 'getWeekDates',
      getCurrentDayDate: 'getCurrentDayDate',
      getPrevDayDate: 'getPrevDayDate',
      getNextDayDate: 'getNextDayDate',
      getJourneysOfCurrentDay: 'getJourneysOfCurrentDay',
    }),
    currentDayIndex() {
      if (this.current < 1 || this.current > 7) return
      return this.current - 1
    },
    canAddJourney() {
      return !this.getJourneys.some((j) => j.day > this.currentDayIndex)
    },
    daySteps() {
      return this.steps.filter((s) => s.id > 0 && s.id < 8)
    },
    dayStepIds() {
      return this.daySteps.map((s) => s.id)
    },
    isInDayStep() {
      return this.dayStepIds.includes(this.current)
    },
    nextJourneyStartsFrom() {
      if (!this.lastJourney) return null
      const { origin, destination, origin_type, destination_type, type } = this.lastJourney

      if (type === JourneyType.ROUND || type === JourneyType.SHUTTLE) return { place: origin, type: origin_type }
      return { place: destination, type: destination_type }
    },
    dates() {
      return this.getWeekDates?.days?.map((d) => format(d, 'EEEE, d LLLL yyyy', { locale: it })) ?? []
    },
    canGoBack() {
      return this.current > 0
    },
    continueBtnLabel() {
      if (this.current === 0) return 'Continua'
      if (this.current === 8) return 'Invia questionario'
      if (this.current === 7) return 'Continua'
      return 'Giorno successivo'
    },
    canSubmitted() {
      return this.getJourneys?.length > 0 && this.lastJourney.is_ended
    },
  },
  created() {
    this.current = this.survey?.last_page ?? 0
  },
  methods: {
    ...mapActions('notification', {
      notifySuccess: 'success',
      notifyError: 'error',
    }),
    onClickBack() {
      console.log('Back')
      this.current--
    },
    async onClickContinue() {
      if (this.current === 0) return await this.validateSurveyForm()
      if (this.current === 8) return await this.submitSurvey()

      if (this.current === 7) {
        if (this.getJourneys?.length === 0) {
          await this.$root.$confirm(
            'Impossibile procedere',
            "Per continuare inserire almeno un viaggio in uno dei giorni di rilevazione. Se l'automezzo non è stato utilizzato nella settimana di rilevazione, specificare il motivo nella sezione “Dati impresa” del questionario.",
            {
              color: 'primary',
            }
          )
          return
        }
        if (!this.lastJourney.is_ended) {
          await this.$root.$confirm(
            'Impossibile procedere',
            'In caso di merce residua a bordo è necessario scaricarla nell’ultimo viaggio effettuato nella settimana di rilevazione.',
            {
              color: 'primary',
            }
          )
          return
        }
      }

      return await this.goToNext()
    },
    async goToNext() {
      this.current++
      return await this.$store.dispatch('survey/update', {
        id: this.survey.id,
        data: {
          last_page: this.current > this.survey.last_page ? this.current : this.survey.last_page,
        },
      })
    },
    async validateSurveyForm() {
      const formData = await this.$refs?.frontpageForm?.submit()

      if (!formData) return

      const isStopped = formData.vehicle_stopped || formData.ownership?.changed

      if (isStopped)
        return await this.submitSurvey({
          ...formData,
          journeys: [],
        })

      await this.$store.dispatch('survey/update', {
        id: this.survey.id,
        data: {
          ...formData,
          last_page: this.survey.last_page ? this.survey.last_page : 1,
        },
      })
      this.current++
    },
    async submitSurvey(data = {}) {
      await this.$store.dispatch('surveys/update', {
        id: this.survey.id,
        data: {
          ...data,
          submitted_at: firebase.firestore.FieldValue.serverTimestamp(),
        },
      })
      localStorage.removeItem('TMS_SURVEY_TOKEN')
      await this.$router.push({ name: 'survey-completed' })
      // if (data.vehicle_stopped || data.ownership?.changed) {
      //   data.submitted_at = firebase.firestore.FieldValue.serverTimestamp()
      //   data.journeys = []
      // } else {
      //   // console.log('ATTIVO')
      // }
      // await this.$store.dispatch('surveys/update', { id: this.survey.id, data })
      // if (data.vehicle_stopped || data.ownership?.changed) {
      //   localStorage.removeItem('TMS_SURVEY_TOKEN')
      //   await this.$router.push({ name: 'survey-completed' })
      // } else {
      //   await this.$router.push({ name: 'survey-journeys' })
      // }
    },
    getJourneysByDay(day) {
      return this.survey?.journeys?.filter((j) => j.day === day)
    },
    openNewJourneyDialog() {
      const journey = {
        day: this.currentDayIndex,
        previous_id: this.lastJourney?.id,
        next_id: null,
        origin: this.nextJourneyStartsFrom ? this.nextJourneyStartsFrom.place : this.newJourneyForm.from,
        origin_type: this.nextJourneyStartsFrom ? this.nextJourneyStartsFrom.type : this.newJourneyForm.from_type,

        destination: this.newJourneyForm.to,
        destination_type: this.newJourneyForm.to_type,

        coupled_vehicle: this.lastJourney?.coupled_vehicle,
        coupled_vehicle_axles: this.lastJourney?.coupled_vehicle_axles,
        coupled_vehicle_load_capacity: this.lastJourney?.coupled_vehicle_load_capacity,
      }

      this.formProps = {
        journey,
        previousJourney: this.lastJourney,
        nextJourney: null,
        dates: this.dates,
      }
      this.dialog = true
    },
    async onJourneyFormSubmit(data) {
      console.log('onJourneyFormSubmit')
      const create = !data.id

      try {
        if (create) {
          await this.$store.dispatch('survey/pushJourney', data)
          // TODO: ADD notify
          // TODO: RESET journeyFormData
          this.newJourneyForm = {
            from: null,
            from_type: null,
            to: null,
            to_type: null,
          }
          // TODO: ADD scroll to bottom
          return
        }
        await this.$store.dispatch('survey/updateJourney', data)
        // TODO: ADD notify
      } catch (error) {
        console.error(error)
        this.notifyError(error)
      } finally {
        this.dialog = false
      }
    },
    async onEdit(journey) {
      console.log('EDIT', journey)
      this.formProps = {
        previousJourney: this.$store.getters['survey/getPreviousJourney'](journey),
        journey,
        nextJourney: this.$store.getters['survey/getNextJourney'](journey),
        dates: this.dates,
      }

      this.dialog = true
    },
    async onDelete(journey) {
      const confirm = await this.$root.$confirm('Elimina viaggio', 'Vuoi davvero eliminare questo viaggio?', {
        color: 'red',
      })

      if (!confirm) return

      try {
        await this.$store.dispatch('survey/popJourney')
        this.notifySuccess('Viaggio eliminato')
      } catch (error) {
        this.notifyError(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
